import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

function PrivacyPage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/legal/privacy')
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(data => setPage(data))
      .catch(() => setPage(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F1A] text-white px-4 py-12">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Link to="/signup" className="text-gray-400 hover:text-white text-sm">← Back to Signup</Link>
        </div>
        <div className="flex items-center gap-3 mb-6">
          <Logo size="md" />
          <h1 className="text-2xl font-bold">{page?.title ?? 'Privacy Policy'}</h1>
        </div>
        <p className="text-gray-400 text-sm mb-8">
          Last updated: {page?.last_updated ?? '—'}
        </p>

        {loading && (
          <div className="space-y-6">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="h-4 bg-[#1F2937] rounded w-1/3 mb-3" />
                <div className="h-3 bg-[#1F2937] rounded w-full mb-2" />
                <div className="h-3 bg-[#1F2937] rounded w-5/6" />
              </div>
            ))}
          </div>
        )}

        {!loading && !page && (
          <p className="text-gray-400 text-sm">Unable to load content. Please try again later.</p>
        )}

        {!loading && page && (
          <div className="space-y-8 text-gray-300 leading-relaxed">
            {(page.sections || []).map((s, i) => (
              <section key={i}>
                <h2 className="text-lg font-semibold text-white mb-3">{s.heading}</h2>
                <p>{s.body}</p>
              </section>
            ))}
          </div>
        )}

        <div className="mt-12 pt-8 border-t border-[#1F2937]">
          <Link to="/signup" className="text-emerald-400 hover:text-emerald-300 text-sm font-medium">← Back to Signup</Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
